import { createTelemetryQueryClient } from '@klareospace/pharos-lib-web-utils';
import { telemetryClient } from './telemetry';

export const queryClient = createTelemetryQueryClient(telemetryClient);
